export default "__VITE_ASSET__CGRd6NEo__"